export const GET_SNACKBAR = "GET_SNACKBAR";
export const GET_IS_LOADING = "GET_IS_LOADING";

export const updateSnackbar = (data) => {
  return {
    type: GET_SNACKBAR,
    payload: {
      snackbar: data,
    },
  };
};

export const updateIsLoading = (data) => {
  return {
    type: GET_IS_LOADING,
    payload: {
      isLoading: data,
    },
  };
};
